module.exports = __webpack_public_path__ + "src/assets/games/42/5.jpg";